// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"23":"ef30a66e","83":"b5dda5ad"}[chunkId] + ".js";
};